export enum HouseNumberSelector {
  onlyEvenHouseNumbers = 1,
  onlyOddHouseNumbers,
}
